import { otpReducer } from "./APICALL/reducer";
import { combineReducers } from "redux";
export const rootReducer = combineReducers({
  otp: otpReducer,
});
